import { AnimatePresence, motion } from "framer-motion";
import { Trash2 } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { CATEGORY_COLORS, fmtMMDDYYYY, money } from "./expenseUtils";

export const ExpenseList = ({ items, hasAny, onDelete }) => {
  const { t } = useLang();

  if (items.length === 0) {
    return (
      <p className="py-14 text-center text-sm text-slate-500" data-testid="expenses-empty">
        {hasAny ? t("exp_empty_filter") : t("exp_empty")}
      </p>
    );
  }

  return (
    <ul className="divide-y divide-[#203859]" data-testid="expenses-list">
      <AnimatePresence initial={false}>
        {items.map((e) => (
          <motion.li
            key={e.id}
            layout
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, x: 24 }}
            transition={{ duration: 0.2 }}
            className="group grid grid-cols-[auto_1fr_auto_auto] items-center gap-3 sm:gap-5 px-3 sm:px-5 py-3.5 hover:bg-white/[0.03] transition-colors duration-200"
            data-testid={`expense-row-${e.id}`}
          >
            <span
              className="h-2.5 w-2.5 rounded-full shrink-0"
              style={{ backgroundColor: CATEGORY_COLORS[e.category] || CATEGORY_COLORS.other }}
            />
            <div className="min-w-0">
              <p className="font-display font-bold text-white text-sm sm:text-base truncate">
                {t(`cat_${e.category}`)}
                {e.note && (
                  <span className="font-body font-normal text-slate-400"> · {e.note}</span>
                )}
              </p>
              <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500">
                {fmtMMDDYYYY(e.date)}
              </p>
            </div>
            <p
              className="font-display font-extrabold text-white tabular-nums text-base sm:text-lg"
              data-testid={`expense-amount-${e.id}`}
            >
              {money(e.amount)}
            </p>
            <button
              onClick={() => onDelete(e)}
              aria-label={t("exp_delete")}
              className="rounded-full p-2 text-slate-600 hover:text-white hover:bg-red-600 transition-colors duration-200 sm:opacity-0 sm:group-hover:opacity-100 focus:opacity-100"
              data-testid={`expense-delete-${e.id}`}
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </motion.li>
        ))}
      </AnimatePresence>
    </ul>
  );
};
